import { useEffect, useState } from "react";
import useScreenSize from "./useScreenSize";

const useScrollHeight = (ref) => {
  const screenSize = useScreenSize();

  const [isVisible, setVisiblility] = useState(false);

  useEffect(() => {
    if (ref?.current) {
      setVisiblility(
        ref?.current?.getBoundingClientRect?.()?.height <
          ref?.current.scrollHeight
      );
    }
  }, [screenSize, ref?.current]);

  return isVisible;
};

export default useScrollHeight;
